import { useState, useEffect } from 'react';

const useGuides = () => {
  const [guides, setGuides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchGuides = async () => {
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/resources/data/guides.json`);
        
        if (!response.ok) {
          throw new Error('Không thể tải dữ liệu hướng dẫn');
        }
        
        const data = await response.json();
        
        if (data && data.guides) {
          setGuides(data.guides);
          
          // Extract unique categories
          const uniqueCategories = [...new Set(data.guides.map(guide => guide.category))];
          setCategories(uniqueCategories);
        }
        
        setLoading(false);
      } catch (err) {
        console.error('Lỗi khi tải hướng dẫn:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchGuides();
  }, []);

  // Find guide by slug
  const getGuideBySlug = (slug) => {
    return guides.find(guide => guide.slug === slug) || null;
  };

  // Find guide by ID
  const getGuideById = (id) => {
    return guides.find(guide => guide.id === Number(id)) || null;
  };

  // Filter guides by category
  const filterByCategory = (category) => {
    if (!category || category === 'all') {
      return guides;
    }
    return guides.filter(guide => guide.category === category);
  };

  return {
    guides,
    categories,
    loading,
    error,
    getGuideBySlug,
    getGuideById,
    filterByCategory
  };
};

export default useGuides;
